import React from 'react';
import { useIntl } from 'react-intl';
import { floor } from 'lodash';

import { Currency } from 'components';
import globalMessages from 'messages';

import './betDetails.scss';

export enum TotalType {
    stake = 'stake',
    odd = 'odd',
}

interface Props {
    total: number | string | JSX.Element;
    totalType: TotalType;
    totalWin: number;
    error?: string[];
}

function formatTotal(v: number | string | JSX.Element) {
    if (typeof v !== 'number') return v;

    return floor(v, 2);
}

const mappingMsg = {
    [TotalType.stake]: globalMessages.totalStake,
    [TotalType.odd]: globalMessages.totalOdd,
};

const BetDetails: React.FC<Props> = ({ total, totalType, totalWin, error }) => {
    const { formatMessage } = useIntl();
    const suffix = totalType === TotalType.stake && <Currency />;

    return (
        <div styleName="container">
            {error ? (
                <div styleName="error">{error}</div>
            ) : (
                <div styleName="total" className="__app-BetDetails-total">
                    <div styleName="label">
                        {formatMessage(mappingMsg[totalType])}
                    </div>
                    <div styleName="value">
                        {formatTotal(total)}
                        {suffix}
                    </div>
                </div>
            )}
            <div styleName="total-win">
                <div styleName="label">
                    {formatMessage(globalMessages.totalWin)}
                </div>
                <div styleName="value">
                    {formatTotal(totalWin)}
                    <Currency />
                </div>
            </div>
        </div>
    );
};

export default BetDetails;
